import React, { ReactElement, useState } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'utils/localization';
import Button from 'components/forms/Button';
import { PaymentService } from 'services/payment.service';
import { RequireAtLeastOne } from 'types/types';
import { MessageType, pushMessage } from 'components/layouts/Toast';

interface Props {
    anyWidth?: boolean;
    className?: string;
    bulkMembershipId?: number;
    applicationId?: string;
    personId?: string;
}

const PayButton = ({
    applicationId,
    personId,
    bulkMembershipId,
    anyWidth,
    className,
}: RequireAtLeastOne<
    Props,
    'applicationId' | 'personId' | 'bulkMembershipId'
>): ReactElement => {
    const { t } = useTranslation();
    const router = useRouter();

    const [loading, setLoading] = useState(false);
    const submit = async () => {
        setLoading(true);
        const response = applicationId
            ? await new PaymentService().createApplication(applicationId)
            : personId
            ? await new PaymentService().createPerson(personId)
            : await new PaymentService().createBulk(bulkMembershipId);
        if (
            !response ||
            (response.message && response.message === 'pay_u_access_token_api')
        ) {
            pushMessage(
                'payment_state_payu_connection_failed',
                MessageType.DANGER
            );
            setLoading(false);
        }
        if (response && response.data) {
            router.replace(response.data);
        }
    };

    return (
        <Button
            className={className}
            anyWidth={anyWidth}
            onClick={submit}
            isLoading={loading}
        >
            {t('Payment.payAction') as string}
        </Button>
    );
};

export default PayButton;
